import { Card, Col, Row } from "antd";
import { ADD_TO_SLACK_URL } from "../../utils/constants";
import AddDiscord from "../AddDiscord/AddDiscord";
import Billing from "./Billing";
import SlackUserSettings from "./SlackUserSettings";
import Admin from "./Admin";
import UserSettings from "./UserSettings";

type Props = {
  currentPlatform: "slack" | "discord" | null;
};

/**
 * Displays general tab of settings for slack or discord
 * @param props props (currentPlatform: slack or discord)
 * @returns JSX
 */
export default function ({ currentPlatform }: Props) {
  const newPlatFormCol = (
    <Col span={12}>
      <Card title="Add a new platform" bordered={false}>
        <p>
          Pick a new platform to add. You&apos;ll then be able to select the new
          workspace in the selector in the top-left.
        </p>
        <div>
          <h4>Slack</h4>
          <a
            onClick={() =>
              window.analytics.track(
                "Clicked on add to slack button in settings"
              )
            }
            href={`${ADD_TO_SLACK_URL}/auth/reauthorized/`}
          >
            <img
              alt="Reauthorize"
              height="40"
              width="139"
              src="https://platform.slack-edge.com/img/add_to_slack.png"
              srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
            />
          </a>
        </div>
        <div className="mt-5">
          <h4>Discord</h4>
          <AddDiscord />
        </div>
        <div className="mt-5">
          <h4>Something else?</h4>
          <p>
            Contact us for Zapier access to integrate with 100+ other platforms.
            Or we have an API where you can build your own integration!
          </p>
        </div>
      </Card>
    </Col>
  );

  if (currentPlatform === "slack") {
    return (
      <Row style={{ paddingBottom: 40 }} gutter={[32, 32]}>
        <Col span={12}>
          <SlackUserSettings></SlackUserSettings>
        </Col>
        {newPlatFormCol}
        <Col span={12}>
          <Card title="Add new team member" bordered={false} className="mt-20">
            <div>
              <h4>
                Please ask your team member to sign up at{" "}
                <a href="https://app.dots.community/onboarding">
                  https://app.dots.community/onboarding
                </a>
              </h4>
              <p>
                If they aren't admin in your Slack workspace, once they sign up,
                have them reach out to us through support so we can manually add
                them to the team. If they are an admin on your Slack workspace,
                they will be automatically added
              </p>
            </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Re-authorize" bordered={false} className="mt-20">
            <>
              <h4>Re-authorize slack by clicking below</h4>
              <a href={`${ADD_TO_SLACK_URL}/auth/reauthorized/`}>
                <img
                  alt="Reauthorize"
                  height="40"
                  width="139"
                  src="https://platform.slack-edge.com/img/add_to_slack.png"
                  srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x"
                />
              </a>
            </>
          </Card>
        </Col>
      </Row>
    );
  } else {
    return (
      <Row style={{ paddingBottom: 40 }} gutter={[32, 32]}>
        <Col span={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Card
              title="Billing"
              extra={
                <a
                  href="https://www.dots.community/#pricing-section"
                  target="_blank"
                >
                  <div className="flex row">
                    <span>View Full feature list</span>
                    <span>
                      <img
                        alt="Link"
                        width="16"
                        className="pt-0.5 ml-2"
                        src="/external-link.svg"
                      />
                    </span>
                  </div>
                </a>
              }
              bordered={false}
              className="mt-20"
              style={{ height: "45%" }}
            >
              <Billing />
            </Card>
            <Card
              title="Add new team member"
              bordered={false}
              className="mt-20"
              style={{ height: "45%" }}
            >
              <p>
                Reach out through chat or email us at{" "}
                <a href="mailto:hello@dots.community">hello@dots.community</a>
              </p>
            </Card>
          </div>
        </Col>
        {newPlatFormCol}
        <Col span={12}>
          <Card title="Admin" bordered={false} className="mt-20">
            <Admin />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="User settings" bordered={false} className="mt-20">
            <UserSettings />
          </Card>
        </Col>
      </Row>
    );
  }
}
